import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
import { ProductType } from '@features/product/components/Collection/Collection.types';
import { CollectionTitle } from '@features/product/components/Collection/Shared';
import { Fragment } from 'react';

type MobileEntranceProps = {
  isInternalUser?: boolean;
  handleOpenModal: () => void;
  collectionTitle: string;
  productType?: ProductType | null;
  currentValues: string[];
  valueSeparator: string;
};

export const MobileEntrance = ({
  isInternalUser = false,
  handleOpenModal,
  collectionTitle,
  productType,
  currentValues,
  valueSeparator
}: MobileEntranceProps) => (
  <Flex
    {...(isInternalUser && { 'data-cy': 'mobile-entrance' })}
    onClick={handleOpenModal}
    justifyContent='space-between'
    alignItems='center'
    p={300}
    sx={{
      border: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.interactiveBase}`,
      borderRadius: freddyTheme.borderRadius[100]
    }}
  >
    <Flex gap={100} sx={{ overflow: 'hidden' }}>
      <CollectionTitle title={collectionTitle} productType={productType} variant='entrance' />
      {currentValues.map((currentValue, index) => {
        const totalValues = currentValues.length;

        return (
          currentValue && (
            <Fragment key={index}>
              <Typography
                m={0}
                sx={{
                  whiteSpace: 'nowrap',
                  ...(index === totalValues - 1 && {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  })
                }}
              >
                {currentValue}
              </Typography>
              {index < totalValues - 1 && (
                <Typography m={0} color='additional'>
                  {valueSeparator}
                </Typography>
              )}
            </Fragment>
          )
        );
      })}
    </Flex>
    <ArrowRight color={freddyTheme.color.icon.interactiveDisabled} />
  </Flex>
);
